module.exports = reduxSelectors.session;